import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import Loader from "../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import { MdEdit } from "react-icons/md";
import WarehouseMasterService from "../services/WarehouseMasterService";
const WarehouseMaster = ({ isLoggedIn }) => {
  const warehouseMasterService = new WarehouseMasterService();
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDt",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0
  });
  const [state, setStatee] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: []
  });
  const [formData, setFormData] = useState({
    warehouseCode: "",
    warehouseName: "",
    email: "",
    MobNo: "",
    country: "",
    state: "",
    city: "",
    address1: "",
    address2: "",
    pincode: "",
    IsActive: true
  });
  const [states, setState] = useState([]);
  const [cities, setCity] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [formErrors, setFormErrors] = useState({
    warehouseCode: "",
    warehouseName: "",
    email: "",
    MobNo: "",
    // password: '',
    // Cpassword: '',
    country: "",
    state: "",
    city: "",
    address1: "",
    address2: "",
    pincode: ""
  });

  const openDialog = (isAdd) => {
    if (isAdd) {
      setShowDialog(true);
      setSelectedRow(null);
    } else {
      setShowDialog(true);
    }
  };
  const handleButtonClick = (row) => {
    const editMode = () => {
      setSelectedRow(row);
      GetStates(row.country);
      GetCities(row.state);
      setFormData({
        warehouseName: row.warehouseName || "",
        email: row.email || "",
        MobNo: row.mobileNo || "",
        // password: row.password || '',
        // Cpassword: row.password || '',
        location: row.city || "",
        IsActive: row.isActive || false,
        warehouseCode: row.warehouseCode || "",
        country: row.country || "",
        state: row.state || "",
        city: row.city || "",
        address1: row.address1 || "",
        address2: row.address2 || "",
        pincode: row.pincode || ""
      });
      if (row) {
        openDialog(false); // Edit action
      } else {
        openDialog(true); // Add action
      }
    };
    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2
            rounded text-sm  hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };
  const handleFormChange = (event) => {
    const { name, value, checked, type } = event.target;
    if (name === "country") {
      GetStates(value);
    }
    if (name === "state") {
      GetCities(value);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value
    }));

    validateForm(name, value);
  };

  const validateForm = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
    const errors = formErrors;
    let IsValid = true;
    switch (name) {
      case "warehouseCode":
        if (value.length < 1) {
          IsValid = false;
          errors.warehouseCode = "Please enter warehouse code.";
        } else errors.warehouseCode = "";
        break;
      case "warehouseName":
        if (value.length < 1) {
          IsValid = false;
          errors.warehouseName = "Please enter warehouse name.";
        } else errors.warehouseName = "";
        break;
      case "email":
        if (value.length < 1) {
          IsValid = false;
          errors.email = "Please enter email-id.";
        } else if (value.length >= 1) {
          /* eslint-disable */
          if (!value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
            IsValid = false;
            errors.email = "Please enter valid email-id.";
          } else errors.email = "";
          /* eslint-enable */
        } else errors.email = "";
        break;
      case "MobNo":
        if (value.length < 1) {
          IsValid = false;
          errors.MobNo = "Please enter mobile no.";
        } else if (value.length >= 1) {
          if (!value.match(/^[6-9]\d{9}$/)) {
            IsValid = true;
            errors.MobNo = "Please enter valid mobile no.";
          } else errors.MobNo = "";
        } else errors.MobNo = "";
        break;
      case "country":
        if (value.length < 1) {
          IsValid = false;
          errors.country = "country is required";
        } else errors.country = "";
        break;
      case "state":
        if (value.length < 1) {
          IsValid = false;
          errors.state = "state is required.";
        } else errors.state = "";
        break;
      case "city":
        if (value.length < 1) {
          IsValid = false;
          errors.city = "city is required.";
        } else errors.city = "";
        break;
      case "address1":
        if (value.length < 1) {
          IsValid = false;
          errors.address1 = "address is required.";
        } else errors.address1 = "";
        break;
      case "address2":
        if (value.length < 1) {
          IsValid = false;
          errors.address2 = "address is required.";
        } else errors.address2 = "";
        break;
      case "pincode":
        if (value.length !== 6 || !/^\d{6}$/.test(value)) {
          IsValid = false;
          errors.pincode = "Please enter a valid 6-digit pincode for India.";
        } else {
          errors.pincode = "";
        }
        break;

      default:
        break;
    }

    setFormErrors(errors);
    return IsValid;
  };

  function GetStates(Ccode) {
    warehouseMasterService
      .GetStates(Ccode)
      .then((response) => {
        const data = response.responseData;
        setState(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  function GetCities(StateId) {
    warehouseMasterService
      .GetCities(StateId)
      .then((response) => {
        const data = response.responseData;
        setCity(data);
      })
      .catch((error) => {
        console.error("API request failed:", error);
      });
  }

  const closeDialog = () => {
    setShowDialog(false);
    GetWarehouses();
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let isfrmvalid = true;
    let checkerror = formErrors;

    Object.entries(checkerror).map(([key, value]) => {
      const val = formData[key];
      let valid = validateForm(key, val);
      if (!valid) {
        setFormErrors(checkerror);
        isfrmvalid = false;
      }
      return isfrmvalid;
    });

    if (isfrmvalid) {
      if (selectedRow) {
        // Editing existing warehouse
        try {
          setStatee((prevData) => ({
            ...prevData,
            loading: true
          }));
          const userData = {
            UserId: selectedRow.id,
            WarehouseCode: formData.warehouseCode,
            WarehouseName: formData.warehouseName,
            email: formData.email,
            MobileNo: formData.MobNo,
            Country: formData.country,
            State: formData.state,
            City: formData.city,
            Address1: formData.address1,
            Address2: formData.address2,
            Pincode: formData.pincode,
            IsActive: formData.IsActive
          };

          warehouseMasterService
            .CreateUpdateWarehouse(userData)
            .then((response) => {
              setStatee((prevData) => ({
                ...prevData,
                loading: false
              }));
              if (response.responseCode === "200") {
                toast.success("Warehouse Updated Successfully!");
                setFormData({
                  WarehouseCode: "",
                  WarehouseName: "",
                  email: "",
                  MobileNo: "",
                  Country: "",
                  State: "",
                  City: "",
                  Address1: "",
                  Address2: "",
                  Pincode: "",
                  IsActive: true
                });
                setSelectedRow(null);
                setShowDialog(false);
                GetWarehouses();
              } else if (response.responseCode === "400") {
                toast.error(response.responseMessage);
              }
            });
        } catch (error) {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("User Update failed:", error);
          toast.error(error.message);
        }
      } else {
        try {
          setStatee((prevData) => ({
            ...prevData,
            loading: true
          }));
          const FormDATA = {
            WarehouseCode: formData.warehouseCode,
            WarehouseName: formData.warehouseName,
            email: formData.email,
            MobileNo: formData.MobNo,
            Country: formData.country,
            State: formData.state,
            City: formData.city,
            Address1: formData.address1,
            Address2: formData.address2,
            Pincode: formData.pincode,
            IsActive: formData.IsActive
          };
          warehouseMasterService
            .CreateUpdateWarehouse(FormDATA)
            .then((response) => {
              setStatee((prevData) => ({
                ...prevData,
                loading: false
              }));

              if (response.responseCode === "200") {
                toast.success("Warehouse created successfully!");
                setFormData({
                  warehouseCode: "",
                  warehouseName: "",
                  email: "",
                  MobNo: "",
                  // password: '',
                  // Cpassword: '',
                  country: "",
                  state: "",
                  city: "",
                  address1: "",
                  address2: "",
                  pincode: "",
                  IsActive: false
                });
              } else if (response.responseCode === "400") {
                toast.error(response.responseMessage);
              }
            });
        } catch (error) {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
          console.error("Warehouse Creation failed:", error);
          toast.error(error.message);
        }
      }
      closeDialog();
      GetWarehouses();
    }
  };

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (storedToken) {
      isLoggedIn(true);
      Promise.all([GetWarehouses()])
        .then(() => {
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setStatee((prevData) => ({
            ...prevData,
            loading: false
          }));
        });
    } else {
      isLoggedIn(false);
      navigate("/login");
    }
    setStatee((prevData) => ({
      ...prevData,
      loading: false
    }));
  }, [isLoggedIn, navigate, setFormData]);

  function GetWarehouses() {
    warehouseMasterService
      .GetWarehouses(tableRequest)
      .then((response) => {
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setStatee((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setStatee((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setStatee((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }
  const initialFormData = {
    warehouseCode: "",
    warehouseName: "",
    email: "",
    MobNo: "",
    // password: '',
    // Cpassword: '',
    country: "",
    state: "",
    city: "",
    address1: "",
    address2: "",
    pincode: "",
    IsActive: true
  };
  const handleDialogClose = () => {
    setShowDialog(false);
    setFormData(initialFormData);
    setFormErrors({
      warehouseCode: "",
      warehouseName: "",
      email: "",
      MobNo: "",
      // password: '',
      // Cpassword: '',
      country: "",
      state: "",
      city: "",
      address1: "",
      address2: "",
      pincode: ""
    });
  };

  const searchFilter = (e) => {
    const value = e.target.value;
    setStatee((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetWarehouses();
  };

  const getLazyLoadingValues = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    GetWarehouses();
  };

  const onPage = (event) => {
    setStatee((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    GetWarehouses();
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          Warehouse Master
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
        <Button
          onClick={openDialog}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          type="button"
        >
          (+) Add Warehouse
        </Button>
      </div>
    </div>
  );

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div className="mt-3">
          <div className="container-fluid mt-3 mb-3">
            <div className="mt-3">
              <div className="container-fluid mt-3 mb-3">
                <DataTable
                  exportFilename="UserMaster"
                  responsive={true}
                  header={header}
                  globalFilter={state.globalFilter}
                  emptyMessage={state.emptyMessage}
                  value={state.sales}
                  paginator={true}
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                  rows={state.rows}
                  rowsPerPageOptions={[10, 50, 200, 500]}
                  totalRecords={state.totalRecords}
                  lazy={true}
                  first={state.first}
                  onPage={onPage}
                  onSort={onSort}
                  className="p-datatable-responsive"
                >
                  <Column
                    field="warehouseName"
                    header="Warehouse Name"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="warehouseCode"
                    header="Warehouse Code"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="mobileNo"
                    header="Mobile Number"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="email"
                    header="Email"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="stateName"
                    header="State"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="cityName"
                    header="City"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                  <Column
                    field="formattedCreatedDate"
                    header="Created Date"
                    sortable={true}
                    style={{ width: "100px" }}
                  />
                  <Column
                    body={handleButtonClick}
                    header="Action"
                    sortable={false}
                    style={{ width: "100px" }}
                  />
                </DataTable>
              </div>
            </div>
          </div>

          <Dialog
            open={showDialog}
            onClose={handleDialogClose}
            PaperProps={{ style: { backgroundColor: "black" } }}
            className="add"
          >
            <DialogTitle style={{ color: "white", textAlign: "center" }}>
              {selectedRow ? "Update Warehouse" : "Add Warehouse"}
            </DialogTitle>
            <form onSubmit={handleFormSubmit}>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Warehouse Code <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="warehouseCode"
                      value={formData.warehouseCode}
                      onChange={handleFormChange}
                      placeholder="Enter Warehouse Code"
                      fullWidth
                      error={!!formErrors.warehouseCode}
                      helperText={formErrors.warehouseCode}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Warehouse Name <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="warehouseName"
                      value={formData.warehouseName}
                      onChange={handleFormChange}
                      placeholder="Enter Warehouse Name"
                      fullWidth
                      error={!!formErrors.warehouseName}
                      helperText={formErrors.warehouseName}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Email <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleFormChange}
                      placeholder="Enter Email"
                      fullWidth
                      error={!!formErrors.email}
                      helperText={formErrors.email}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Mobile Number <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="MobNo"
                      value={formData.MobNo}
                      onChange={handleFormChange}
                      placeholder="Enter Mobile No."
                      fullWidth
                      error={!!formErrors.MobNo}
                      helperText={formErrors.MobNo}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Pincode <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="pincode"
                      value={formData.pincode}
                      onChange={handleFormChange}
                      placeholder="Enter pincode"
                      fullWidth
                      error={!!formErrors.pincode}
                      helperText={formErrors.pincode}
                    />

                    {/* <TextField
                                            margin="dense"
                                            label={
                                                <span>
                                                    Password <span className="text-red-500">*</span>
                                                </span>
                                            }
                                            type="password"
                                            name='password'
                                            value={formData.password}
                                            onChange={handleFormChange}
                                            placeholder="Enter Password "
                                            fullWidth
                                            error={!!formErrors.password}
                                            helperText={formErrors.password}
                                        />
                                        <TextField
                                            margin="dense"
                                            label={
                                                <span>
                                                    Confirm Password <span className="text-red-500">*</span>
                                                </span>
                                            }
                                            type="password"
                                            name='Cpassword'
                                            value={formData.Cpassword}
                                            onChange={handleFormChange}
                                            placeholder="Enter Confirm password"
                                            fullWidth
                                            error={!!formErrors.Cpassword}
                                            helperText={formErrors.Cpassword}
                                        /> */}
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.country}
                    >
                      <InputLabel id="countryDropdown">
                        <span>
                          Country <span className="text-red-500">*</span>
                        </span>
                      </InputLabel>
                      <Select
                        labelId="countryDropdown"
                        value={formData.country}
                        name="country"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300 // Set your desired maxHeight here
                            }
                          }
                        }}
                      >
                        {/* Displaying only one option */}
                        <MenuItem value="101">India</MenuItem>
                      </Select>
                      {!!formErrors.country && (
                        <FormHelperText>{formErrors.country}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.state}
                    >
                      <InputLabel id="stateDropdown">
                        <span>
                          State <span className="text-red-500">*</span>
                        </span>
                      </InputLabel>
                      <Select
                        labelId="stateDropdown"
                        value={formData.state}
                        name="state"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300 // Set your desired maxHeight here
                            }
                          }
                        }}
                      >
                        {states.map((state) => (
                          <MenuItem key={state.stateId} value={state.stateId}>
                            {state.state}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!formErrors.state && (
                        <FormHelperText>{formErrors.state}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl
                      fullWidth
                      margin="dense"
                      error={!!formErrors.city}
                    >
                      <InputLabel id="cityDropdown">
                        <span>
                          City <span className="text-red-500">*</span>
                        </span>
                      </InputLabel>
                      <Select
                        labelId="cityDropdown"
                        value={formData.city}
                        name="city"
                        onChange={handleFormChange}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300 // Set your desired maxHeight here
                            }
                          }
                        }}
                      >
                        {cities.map((city) => (
                          <MenuItem key={city.cityId} value={city.cityId}>
                            {city.city}
                          </MenuItem>
                        ))}
                      </Select>
                      {!!formErrors.city && (
                        <FormHelperText>{formErrors.city}</FormHelperText>
                      )}
                    </FormControl>
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Address 1 <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="address1"
                      value={formData.address1}
                      onChange={handleFormChange}
                      placeholder="Enter Address"
                      fullWidth
                      error={!!formErrors.address1}
                      helperText={formErrors.address1}
                    />
                    <TextField
                      margin="dense"
                      label={
                        <span>
                          Address 2 <span className="text-red-500">*</span>
                        </span>
                      }
                      type="text"
                      name="address2"
                      value={formData.address2}
                      onChange={handleFormChange}
                      placeholder="Enter Address"
                      fullWidth
                      error={!!formErrors.address2}
                      helperText={formErrors.address2}
                    />
                  </Grid>
                </Grid>
                <div className="row">
                  <div className="col-md-6">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData.IsActive}
                          onChange={handleFormChange}
                          name="IsActive"
                          color="primary"
                        />
                      }
                      label="Active"
                      error={!!formErrors.IsActive}
                      helperText={formErrors.IsActive}
                    />
                  </div>
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className="sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};
export default WarehouseMaster;
